import { useState } from 'react';
import { toAreaSlug } from '../../utils/normalize';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [megaMenuOpen, setMegaMenuOpen] = useState(false);
    const { pathname } = useLocation();

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <header className="header">
            <nav className="navbar">
                <div className="nav-container">
                    {/* Mobile Menu Toggle */}
                    <button
                        className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
                        onClick={toggleMobileMenu}
                        aria-label="القائمة"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    {/* Logo - mobile only (visibility controlled by CSS) */}
                    <div className="logo logo-mobile">
                        <div className="logo-text">
                            <span className="logo-main">ونش انقاذ سيارات</span>
                        </div>
                    </div>

                    {/* Navigation Menu */}
                    <div className={`nav-menu-wrapper ${mobileMenuOpen ? 'active' : ''}`}>
                        {/* Right side menu */}
                        <ul className="nav-menu nav-right">
                            <li className="nav-item">
                                <Link to="/" className={`nav-link ${pathname === '/' ? 'active' : ''}`} onClick={closeMobileMenu}>الرئيسية</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/about" className={`nav-link ${pathname === '/about' ? 'active' : ''}`} onClick={closeMobileMenu}>من نحن</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/services" className={`nav-link ${pathname === '/services' ? 'active' : ''}`} onClick={closeMobileMenu}>الخدمات</Link>
                            </li>
                        </ul>

                        {/* Logo - desktop only (visibility controlled by CSS) */}
                        <div className="logo logo-desktop">
                            <div className="logo-text">
                                <span className="logo-main">ونش انقاذ سيارات</span>
                            </div>
                        </div>

                        {/* Left side menu */}
                        <ul className="nav-menu nav-left">
                            <li className="nav-item mega-menu-parent"
                                onMouseEnter={() => setMegaMenuOpen(true)}
                                onMouseLeave={() => setMegaMenuOpen(false)}
                            >
                                <Link to="/areas/" className={`nav-link ${pathname === '/areas/' ? 'active' : ''}`} onClick={closeMobileMenu}>
                                    المناطق
                                    <span style={{ fontSize: '10px', marginRight: '5px' }}>▼</span>
                                </Link>
                                {megaMenuOpen && <MegaMenu onClose={() => { setMegaMenuOpen(false); closeMobileMenu(); }} />}
                            </li>
                            <li className="nav-item">
                                <Link to="/articles" className={`nav-link ${pathname === '/articles' ? 'active' : ''}`} onClick={closeMobileMenu}>المقالات</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact" className={`nav-link ${pathname === '/contact' ? 'active' : ''}`} onClick={closeMobileMenu}>اتصل بنا</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

const areaGroups = [
    {
        title: "القاهرة الجديدة والمدن الجديدة",
        areas: ["التجمع الخامس", "التجمع الاول", "التجمع الثالث", "مدينتي", "الرحاب", "الشروق", "العاصمة الإدارية"]
    },
    {
        title: "شرق القاهرة",
        areas: ["مدينة نصر", "مصر الجديدة", "شيراتون", "النزهة", "العباسية", "السلام", "العبور"]
    },
    {
        title: "المعادي وجنوب القاهرة",
        areas: ["المعادي", "زهراء المعادي", "صقر قريش", "المقطم", "القطامية"]
    },
    {
        title: "الجيزة والطرق السريعة",
        areas: ["أكتوبر", "الشيخ زايد", "الزمالك", "الدائري", "طريق السويس", "طريق السخنة", "اسكندرية", "الساحل الشمالي"]
    }
];

const MegaMenu = ({ onClose }) => {
    return (
        <div className="mega-menu" style={{ display: 'block' }}>
            <div className="mega-menu-container-inner">
                {areaGroups.map((group, index) => (
                    <div key={index} className="mega-menu-column">
                        <span className="mega-menu-title">{group.title}</span>
                        <ul className="mega-menu-list">
                            {group.areas.map((areaName, aIdx) => (
                                <li key={aIdx}>
                                    <Link
                                        to={`/areas/${encodeURIComponent(toAreaSlug(areaName))}/`}
                                        className="mega-menu-link"
                                        onClick={onClose}
                                    >
                                        ونش انقاذ {areaName}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Link to="/areas/" className="mega-menu-title" style={{ border: 'none', fontSize: '15px' }} onClick={onClose}>
                    ← عرض جميع المناطق وتغطية المحافظات
                </Link>
            </div>
        </div>
    );
};

export default Header;


